
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doctors/[doctorId]",
      function () {
        return require("private-next-pages/doctors/[doctorId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doctors/[doctorId]"])
      });
    }
  